/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contacts_EmptyInputs */

const cs_contacts_empty = /** @type {(inputs: Contacts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné kontakty.`)
};

const en_contacts_empty = /** @type {(inputs: Contacts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No contacts yet.`)
};

/**
* | output |
* | --- |
* | "No contacts yet." |
*
* @param {Contacts_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contacts_empty = /** @type {((inputs?: Contacts_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contacts_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contacts_empty(inputs)
	return cs_contacts_empty(inputs)
});